import React, { useState, useEffect } from 'react'
import requests from '../Requests';
import Loader from './Loader';

function YoutubeEmbed() {
    const [youtubeEmbed, setYoutubeEmbed] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [play, setPlay] = useState(false);

    const getYoutubeEmbed = async () => {
        const dataYoutubeEmbed = await fetch(requests.requestYoutubeEmbed, {
            method: 'get',
            headers: new Headers({
                "Authorization": `Bearer ${requests.token_web}`
            })
        });
        const valYoutubeEmbed = await dataYoutubeEmbed.json();
        const resYoutubeEmbed = valYoutubeEmbed.data.attributes;
        const result = {
            "url": resYoutubeEmbed.unique_url,
        }
        setYoutubeEmbed(result);
        setIsLoading(false)
    }

    useEffect(() => {
        getYoutubeEmbed();
    }, [])

    return (
        <div className="w-full max-w-6xl px-10 mx-auto mb-10 md:w-1/2">
            {!play ? (
                <div
                    className="relative cursor-pointer aspect-video"
                    onClick={() => setPlay(true)}
                >
                    <img
                        src={`https://img.youtube.com/vi/${youtubeEmbed.url}/maxresdefault.jpg`}
                        alt="Thumbnail"
                        className="object-cover w-full h-full rounded-xl"
                    />

                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="px-4 py-2 text-white bg-red-600 rounded-full">
                            ▶ Play
                        </div>
                    </div>
                </div>
            ) : (
                <iframe
                    className="w-full aspect-video rounded-xl"
                    src={`https://www.youtube.com/embed/${youtubeEmbed.url}?autoplay=1`}
                    title="YouTube video player"
                    allowFullScreen
                />
            )}
        </div>
    );
}

export default YoutubeEmbed